module.exports = __webpack_public_path__ + "static/media/cross-danger.b277249c.svg";